import { useEffect, useState } from "react";
import style from "./Filter.module.css";
import { setVideoLibraryFilterList } from "../../../../../Redux/Actions/VideoLibraryFilterAction";
import { getFromLocalStorage } from "../../../../../utils/webStorage";
import { useDispatch, useSelector } from "react-redux";
import { BsCircle } from "react-icons/bs";
import { MdModeEdit } from "react-icons/md";
import { FaTrashAlt } from "react-icons/fa";
import { BsFillCheckCircleFill } from "react-icons/bs";
import styles from "./Filter.module.css";
import { openConfirmationPopup } from "../../../../../Redux/Actions/PopupActions";
import { openAddFilterPopup } from "../../../../../Redux/Actions/VideoLibraryFilterAction";
import { setEditFilter } from "../../../../../Redux/Actions/VideoLibraryFilterAction";
import { setEditFilterInformation } from "../../../../../Redux/Actions/VideoLibraryFilterAction";
import { setFilterValues } from "../../../../../Redux/Actions/VideoLibraryFilterAction";
import { Checkbox } from "@mui/material";
const QuickFilter = () => {
  const dispatch = useDispatch();
  const schoolId = getFromLocalStorage("schoolId");
  const [hoveredItem, setHoveredItem] = useState(null);
  const { filterList, filterValues } = useSelector(
    (state) => state?.videoLibraryFilterData
  );
  const { activeBreakDownList } = useSelector(
    (state) => state?.VideoLibraryDataTable
  );
  useEffect(() => {
    setVideoLibraryFilterList(dispatch, {
      breakdowns: activeBreakDownList,
      schoolId: schoolId,
    });
  }, []);

  const handleDelete = (item) => {
    const delfilter = filterValues.filter((ele) => ele?.id != item?.id);
    setFilterValues(dispatch, delfilter);
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        open: true,
        message: `Are You Sure You Want To Delete This Filter?`,
        btnColor: "red",
        btnText: `Delete`,
        type: "Delete Filter",
        id: item.id,
      },
    });
  };

  const handleModelEdit = (item) => {
    openAddFilterPopup(dispatch, { status: true });
    setEditFilter(dispatch, true);
    setEditFilterInformation(dispatch, item);
  };

  const handleChange = (e, item) => {
    const isChecked = e.target.checked;
    const updatedValue = item?.value.split(",");
    let newItem = {
      id: item?.id,
      value: updatedValue,
      operator: null,
      breakDownName: item?.breakdown?.breakdownName,
      filterName: item?.filterName,
    };

    switch (item?.newCriteria) {
      case "EqualTo":
        if (item?.breakdown?.breakdownType?.breakdownTypeName === "Number") {
          newItem = { ...newItem, operator: "===" };
        }
        break;

      case "GreaterThan":
        newItem = { ...newItem, operator: ">" };
        break;

      case "LessThan":
        newItem = { ...newItem, operator: "<" };
        break;

      case "NotEqualTo":
        newItem = { ...newItem, operator: "!==" };
        break;

      default:
        break;
    }
    setFilterValues(
      dispatch,
      isChecked
        ? [...(filterValues || []), newItem]
        : filterValues?.filter((el) => el?.id !== item?.id)
    );
  };
  return (
    <div className={style.maincontainerTooltip}>
      <div className={style.fiterTooltipContentContainer}>
        <ul className={`list-unstyled ${style.appliedFilterList}`}>
          {filterList?.map((filterData, index) => (
            <li
              className={`text-dark ${style.appliedFilterListItem}`}
              key={index}
            >
              <div
                className="d-flex-space-between"
                onMouseEnter={() => setHoveredItem(filterData.id)}
                onMouseLeave={() => setHoveredItem(null)}
              >
                <div className="d-flex-align-cent gap-5">
                  <Checkbox
                    checked={filterValues?.some(
                      (value) => value?.id === filterData?.id
                    )}
                    onChange={(e) => handleChange(e, filterData)}
                    icon={<BsCircle fontSize="20px" color="#13005A" />}
                    checkedIcon={
                      <BsFillCheckCircleFill fontSize="20px" color="#13005A" />
                    }
                    className="videolibrary-checkbox-icon"
                  />
                  <span>{filterData?.filterName}</span>
                </div>
                <div className={`${styles.editDeleteContainerForQuickFilter}`}>
                  <MdModeEdit
                    className={`${
                      hoveredItem === filterData.id
                        ? styles.editIcon
                        : styles.hidden
                    }`}
                    onClick={() => handleModelEdit(filterData)}
                  />
                  <FaTrashAlt
                    className={`${
                      hoveredItem === filterData.id
                        ? styles.deleteIcon
                        : styles.hidden
                    }`}
                    onClick={() => handleDelete(filterData)}
                  />
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <div
        className={`position-fixed ${style.filterContentFooterButtonContainer}`}
      ></div>
    </div>
  );
};

export default QuickFilter;
